import type { User } from "@privy-io/react-auth"

type LinkedAccounts = User["linkedAccounts"] | undefined

export function isGachaEvmAddressLinked(
  linkedAccounts: LinkedAccounts,
  address: string | undefined,
): boolean {
  if (!address) return false
  const normalized = address.toLowerCase()
  return (
    linkedAccounts?.some((account) => {
      if (account.type === "cross_app") {
        return [...account.embeddedWallets, ...account.smartWallets].some(
          (wallet) => wallet.address.toLowerCase() === normalized,
        )
      }
      return (
        ((account.type === "wallet" && account.chainType === "ethereum") ||
          account.type === "smart_wallet") &&
        account.address.toLowerCase() === normalized
      )
    }) ?? false
  )
}

export function getGachaEvmWalletClientType(
  linkedAccounts: LinkedAccounts,
  address: string,
): string | null {
  const account = linkedAccounts?.find(
    (account) =>
      account.type === "wallet" &&
      account.chainType === "ethereum" &&
      account.address.toLowerCase() === address.toLowerCase(),
  )
  if (
    account?.type !== "wallet" ||
    !account.walletClientType ||
    account.walletClientType === "privy" ||
    account.walletClientType === "privy-v2"
  )
    return null
  return account.walletClientType
    .replace(/[-_]wallet$/, "")
    .replace(/[-_]extension$/, "")
    .toLowerCase()
}
